export default __webpack_public_path__ + "static/media/operandio-full.6515b588.svg";